import {Component} from '@angular/core';

@Component({
    selector: 'my-app',
    templateUrl: '../AppViews/app.component.html',  
})

export class AppComponent {    
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/App/app.component.ts
 **/